
import { RelatedServicesSection } from "@/components/services/RelatedServicesSection";
import { laserDentistryData } from "./laserDentistryData";

export const LaserDentistryRelated = () => {
  const handleBookAppointment = () => {
    window.open("https://www.healthcoco.com/nagpur/doctor/dr-hemant-asrani-endodontist-dentist/USRH249D644", "_blank");
  };

  return (
    <RelatedServicesSection
      title="Experience Modern Dental Care"
      description="Contact Asrani Dental in Sadar, Nagpur today to learn more about our laser dentistry services and how they can make your dental experience more comfortable and effective."
      primaryButtonText="Book Appointment"
      secondaryButtonText="Contact Us"
      primaryButtonAction={handleBookAppointment}
      secondaryButtonAction={() => window.location.href = '/contact'}
      relatedServices={laserDentistryData.relatedServices}
    />
  );
};
